import React from 'react';
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Row, Col } from 'antd'

import { pageChanged } from '../../../../../data/redux/page_details/actions'
import * as kpiActions from '../../../../../data/redux/kpi_details/actions'

import { APP_PAGES, APP_LAYOUT } from '../../../../../data/config/constants'
import { IMG_EMPTY } from '../../../../../data/assets/img'

import CustomHeader from '../../../../../components/customheader'
import KpiFilter from './components/kpifilter'
import CardContainer from '../../../components/cardcontainer'
import ChartStatusCard from '../../../components/chartstatuscard'
import ErrorBoundary from '../../../../../components/errorboundary'
import ShowMessage from '../../../../../components/showmessage'

class Kpi extends React.PureComponent {
  componentDidMount() {
    const { actions, kpi_details, admin_id } = this.props
    actions.pageChanged(APP_PAGES.KPI, APP_PAGES.ANALYTICS)
    const payload = {
      ...kpi_details.selected_date_range,
      selectedFilters: kpi_details.selected_filters,
      psid: admin_id
    }
    actions.fetchKpiFilterAndData(payload)
  }

  handleDateRangeChange = date_range => {
    const { actions, kpi_details, admin_id } = this.props;
    const payload = {
      startDate: date_range[0],
      endDate: date_range[1],
      selectedFilters: kpi_details.selected_filters,
      psid: admin_id
    }
    actions.fetchKpiFilterAndData(payload, () => actions.updateKpiState({ startDate: date_range[0], endDate: date_range[1] }, 'selected_date_range'))
  }

  onChangeSelectedFilters = (selected_value, value_key) => {
    const { kpi_details, admin_id, actions } = this.props;
    const payload = {
      ...kpi_details.selected_date_range,
      psid: admin_id,
      selectedFilters: {
        ...kpi_details.selected_filters,
        [value_key]: selected_value
      },
    }
    actions.fetchKpiFilterAndData(payload, () => actions.updateKpiState(selected_value, `selected_filters.${value_key}`))
  }

  clearSelectedFilter = () => {
    const { kpi_details, admin_id, actions } = this.props;
    const payload = {
      ...kpi_details.selected_date_range,
      psid: admin_id,
      selectedFilters: {},
    }
    actions.fetchKpiFilterAndData(payload, () => actions.updateKpiState({}, 'selected_filters'))
  }

  renderKpiStats = () => {
    const { kpi_details } = this.props;
    if (kpi_details.stats_list.length > 0) {
      return kpi_details.stats_list.map((kpi, index1) => {
        switch (kpi.type) {
          case 'statusCard': return (
            <Row key={index1} gutter={10}>
              {
                kpi.stats.map((item, index2) => {
                  return (
                    <ErrorBoundary key={index2}>
                      <Col xs={24} sm={12} md={8} lg={6} className="ori-b-pad-10">
                        <ChartStatusCard card_data={item} tooltip_visible />
                      </Col>
                    </ErrorBoundary>
                  );
                })
              }
            </Row>
          )

          case 'listCard': {
            const custom_header_props = {
              title: kpi.title
            };
            return (
              <CardContainer key={index1} custom_header_props={custom_header_props} container_height={350} card_container_class="ori-animated ori-fade-in ori-box-shadow-light ori-bg-white ori-lr-pad-10 ori-t-mrgn-5 ori-b-mrgn-10 " loading={false} show_custom_header>
                <Row gutter={10}>
                  {
                    kpi.stats.map((item, index2) => {
                      return (
                        <ErrorBoundary key={index2}>
                          <Col xs={24} md={12} lg={8}>
                            <div className="ori-flex-row ori-flex-jsb ori-border-radius-4 ori-pad-10 ori-b-mrgn-10 ori-bg-default">
                              <div className="ori-flex-column ori-flex-jc ori-capitalize ori-overflow-hidden ori-r-pad-5">
                                <span className="ori-text-overflow-dotted">{item.title}</span>
                              </div>
                              <div className="ori-font-bold ori-font-lg ori-l-pad-5">{item.value}</div>
                            </div>
                          </Col>
                        </ErrorBoundary>
                      );
                    })
                  }
                </Row>
              </CardContainer>
            );
          }

          default: return null
        }
      })
    }
    return (
      <div className="ori-l-pad-10 ori-full-parent-height">
        <ShowMessage img_src={IMG_EMPTY} title="EMPTY" message="unable to load kpi details. please check your internet connection and reload the page." height={150} width={150} />
      </div>
    );
  }

  render() {
    const { screen_height, kpi_details, actions } = this.props;
    const container_height = screen_height - APP_LAYOUT.APP_HEADER_HEIGHT - 55;
    return (
      <div className="ori-bg-white">
        <div className="ori-lr-pad-10">
          <CustomHeader title="KPIs" date_range={[kpi_details.selected_date_range.startDate, kpi_details.selected_date_range.endDate]} onChangeDateRange={this.handleDateRangeChange} bottom_bordered show_date_range />
        </div>
        <div className="ori-flex-row">
          <div className="ori-overflow-x-hidden ori-overflow-y-auto ori-r-border-default ori-lr-pad-10 ori-t-pad-5" style={{ width: '250px', height: `${container_height}px` }}>
            <KpiFilter filters={kpi_details.filters} selected_filters={kpi_details.selected_filters} updateKpiState={actions.updateKpiState} onChangeSelectedFilters={this.onChangeSelectedFilters} clearSelectedFilter={this.clearSelectedFilter} />
          </div>
          <div className="ori-full-flex ori-overflow-x-hidden ori-overflow-y-auto ori-t-pad-10 ori-lr-pad-10 ori-bg-default" style={{ height: `${container_height}px` }}>
            {this.renderKpiStats()}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    kpi_details: state.kpi_details,
    screen_height: state.page_details.device_data.screen_height,
    admin_id: state.admin_details.admin_id
  }
}

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(Object.assign({}, { pageChanged }, kpiActions), dispatch),
  }
}

Kpi.propTypes = {
  actions: PropTypes.object,
  screen_height: PropTypes.number,
  kpi_details: PropTypes.object,
  admin_id: PropTypes.string,
};

export default connect(mapStateToProps, mapDispatchToProps)(Kpi);



// WEBPACK FOOTER //
// ./src/app/pagecontainer/modules/analytics/kpi/index.js